import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';
import { DinoLogo } from '@/components/DinoLogo';

export default function TermsOfService() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background w-full max-w-full overflow-x-hidden">
      <header className="sticky top-[var(--header-height)] z-40 border-b border-border bg-background/80 backdrop-blur-sm">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => navigate(-1)}
              className="gap-2"
            >
              <ArrowLeft className="h-4 w-4" />
              Back
            </Button>
            <DinoLogo className="h-8" />
            <div className="w-20" /> {/* Spacer for centering */}
          </div>
        </div>
      </header>

      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <div className="prose prose-slate dark:prose-invert max-w-none">
          <h1 className="text-4xl font-heading font-bold mb-8">Terms of Service</h1>
          
          <div className="bg-muted/50 border border-border rounded-lg p-6 mb-8">
            <p className="text-lg font-medium mb-2">Legal Content Coming Soon</p>
            <p className="text-muted-foreground">
              We're currently preparing our complete Terms of Service. This page will be updated with detailed legal terms soon.
            </p>
          </div>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">Using Dino</h2>
            <p className="mb-4">
              By using Dino, you agree to:
            </p>
            <ul className="list-disc pl-6 space-y-2 mb-4">
              <li>Follow our <a href="/community-guidelines" className="text-primary hover:underline">Community Guidelines</a></li>
              <li>Use the platform responsibly and respectfully</li>
              <li>Not engage in any harmful or illegal activities</li>
              <li>Respect the intellectual property rights of others</li>
              <li>Maintain the accuracy of your account information</li>
            </ul>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">Your Account</h2>
            <p className="mb-4">
              You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account. Please notify us immediately of any unauthorized use.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">Content</h2>
            <p className="mb-4">
              All content you post on Dino remains your property. However, by posting content, you grant Dino a license to display and distribute that content on our platform.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-2xl font-semibold mb-4">Questions?</h2>
            <p>
              If you have questions about these terms, please refer to our{' '}
              <a href="/community-guidelines" className="text-primary hover:underline">
                Community Guidelines
              </a>{' '}
              or contact our support team.
            </p>
          </section>

          <div className="mt-12 pt-8 border-t border-border text-center">
            <Button onClick={() => navigate(-1)} variant="outline">
              Go Back
            </Button>
          </div>
        </div>
      </main>
    </div>
  );
}
